import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=eb5b8fbc&scoped=true&"
import script from "./Accident.vue?vue&type=script&lang=js&"
export * from "./Accident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5b8fbc",
  null
  
)

export default component.exports